module.exports = __webpack_public_path__ + "1d5785e78f8ae449502eb1c5ef6d90b2.svg";